module.exports = __webpack_public_path__ + "static/media/semiconductors_5_tablet.45ad4c39.jpg";